var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.bgTheme},[_c('section',[_c('el-table',{staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"show-header":false,"data":_vm.tableData,"border":"","cell-style":_vm.columnStyle}},[_c('el-table-column',{attrs:{"prop":"name","align":"center"}}),_c('el-table-column',{attrs:{"prop":"value","align":"center"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }